// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"1218":"289f4676","3343":"0690820d","4067":"a17dc98f","4826":"1e7183b1","6873":"93a2698f","7390":"a17dc98f","9432":"dd4984bf","9590":"88413f8f"}[chunkId] + ".chunk.css";
};